import { Box, styled } from "@mui/material";

import { useAppSelector } from "app/redux-store-interactions";

import { selectSelectBox } from "./renderSlice";

const SelectBoxOverlay = styled(Box)({
    position: "absolute",
    border: "2px dashed #1976d2",
    backgroundColor: "rgba(25, 118, 210, 0.1)",
    pointerEvents: "none",
    zIndex: 1000,
});

export function SelectBox() {
    const selectBox = useAppSelector(selectSelectBox);

    if (!selectBox) {
        return null;
    }

    const { startX, endX, startY, endY } = selectBox;
    const left = Math.min(startX, endX);
    const top = Math.min(startY, endY);
    const width = Math.abs(endX - startX);
    const height = Math.abs(endY - startY);

    return (
        <SelectBoxOverlay
            style={{
                left: `${left}px`,
                top: `${top}px`,
                width: `${width}px`,
                height: `${height}px`,
            }}
        />
    );
}
